import * as React from "react";
import styled, { css } from "styled-components";
import Icon from "./Icon";
import Delayed from "./Delayed";
const Container = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: baseline;
`;
const StyledIcon = styled(Icon)(
  ({ $displayMargin }) => css`
    ${$displayMargin ? "margin-right: 6px;" : ""}
  `
);
const Spinner = ({ name = "progress_activity", text = "Loading...", delay = 200, ...rest }) => /* @__PURE__ */ React.createElement(Delayed, { delay }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(StyledIcon, { ...rest, name, $displayMargin: !!(text == null ? void 0 : text.trim()), spin: true }), text));
export default Spinner;
